module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("Настройки")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'cities'
      }
    }
  }, [_vm._v("Города")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'bank-transactions'
      }
    }
  }, [_vm._v("Банковские транзакции")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'rate-plans'
      }
    }
  }, [_vm._v("Тарифные планы")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'discounts'
      }
    }
  }, [_vm._v("Скидки")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'bill-templates'
      }
    }
  }, [_vm._v("Шаблоны квитанций")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'print-orders'
      }
    }
  }, [_vm._v("Заказы печати")])], 1), _vm._v(" "), _c('company-edit-form', {
    attrs: {
      "company": _vm.company
    },
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf37129a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company/CompanyEdit.vue
// module id = 707
// module chunks = 0